export const maxFileSize = 5242880;
export const maxFileSize10Mb = 10485760;